import React from 'react'
import {useStaticQuery, graphql} from 'gatsby'
export const withAllTags = () => {
  const {collaboration} = useStaticQuery(graphql `
    query allCollaborationWithTags {
      collaboration: allWordpressWpCollaboration{
        nodes{
          id
          tags {
            id
            name
          }
        }
      }
    }
`)
  let tags = {}
  collaboration.nodes.forEach((item, index)=>{
    if(item.tags && item.tags.length){
      item.tags.forEach((tag, index)=>{
        if(!tags.hasOwnProperty(tag.id)){
          tags[tag.id]={
            ...tag,
            items: []
          }
        }
        tags[tag.id].items.push(item.id)
      })
    }
  })
  return Object.values(tags);
}